import { createTheme } from '@mui/material/styles';

export const themeConfig = createTheme({
  typography: {
    fontFamily: 'Montserrat Alternates, sans-serif, cursive',
    fontSize: 13,
  },
  components: {
    MuiCard: {
      backgroundColor: '#c71ac47'
    },
    MuiCardContent: {
      backgroundColor: '#c71ac4'
    }
  },
  palette: {
    backgroundColor: '#bbb',
    primary: {
      main: '#c71ac4'
    },
    secondary: {
      main: '#c71ac4'
    },
    info: {
      main: '#c71ac4'
    },
    mode: 'dark'
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1300,
      xl: 1536
    }
  }
});